module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_c('span', [_vm._v("体验卡管理 / 新增")]), _vm._v(" "), _c('el-button', {
    staticClass: "back",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper"
  }, [_c('el-form', {
    ref: "formRef",
    attrs: {
      "label-width": "80px",
      "label-position": "left",
      "model": _vm.formData,
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入名称"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "特权角色",
      "prop": "privilegeRoleId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择特权角色",
      "filterable": ""
    },
    model: {
      value: (_vm.formData.privilegeRoleId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "privilegeRoleId", $$v)
      },
      expression: "formData.privilegeRoleId"
    }
  }, _vm._l((_vm.privilegeOptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "体验时长",
      "prop": "duration"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls": false,
      "min": 0,
      "step": 1
    },
    model: {
      value: (_vm.formData.duration),
      callback: function($$v) {
        _vm.$set(_vm.formData, "duration", $$v)
      },
      expression: "formData.duration"
    }
  }), _vm._v(" "), _c('span', [_vm._v("天")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期",
      "prop": "timeType"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeTimeType
    },
    model: {
      value: (_vm.formData.timeType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "timeType", $$v)
      },
      expression: "formData.timeType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("固定")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("不固定")])], 1), _vm._v(" "), (_vm.formData.timeType == 1) ? _c('div', {
    staticClass: "flex-row"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "起始日期"
    },
    model: {
      value: (_vm.formData.startTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "startTime", $$v)
      },
      expression: "formData.startTime"
    }
  }), _vm._v(" "), _c('div', [_vm._v(" 至 ")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "结束日期"
    },
    model: {
      value: (_vm.formData.endTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "endTime", $$v)
      },
      expression: "formData.endTime"
    }
  })], 1) : _c('div', {
    staticClass: "flex-row"
  }, [_c('span', {
    staticClass: "margin-right-10"
  }, [_vm._v("获得后")]), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "controls": false,
      "min": 0,
      "step": 1
    },
    model: {
      value: (_vm.formData.effectTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "effectTime", $$v)
      },
      expression: "formData.effectTime"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "margin-left-10"
  }, [_vm._v("天内有效")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "库存数量",
      "prop": "quantity"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeQuantityType
    },
    model: {
      value: (_vm.quantityType),
      callback: function($$v) {
        _vm.quantityType = $$v
      },
      expression: "quantityType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("有限")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("无限")])], 1), _vm._v(" "), (_vm.quantityType) ? _c('div', {
    staticClass: "flex-row"
  }, [_c('el-input', {
    on: {
      "input": _vm.inputQuantity
    },
    model: {
      value: (_vm.formData.quantity),
      callback: function($$v) {
        _vm.$set(_vm.formData, "quantity", $$v)
      },
      expression: "formData.quantity"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "margin-left-10"
  }, [_vm._v("张")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.clickSave()
      }
    }
  }, [_vm._v("保存")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8a51697e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/UserAdminister/ExperienceCard/ExperienceCardDetail.vue
// module id = 1099
// module chunks = 0